import classNames from 'classnames';
import { dsClass } from '../../common/constants/dsClasses.js';
import { useDeviceListTabsCoCo } from '../../common/hooks/useDeviceListTabsCoCo.js';
import { deviceListsMsg, deviceSelectionMsg, t } from '../../common/i18n/index.js';
import { DeviceListTabCoCo } from '../../common/utils/deviceListTabsUtilsCoCo.js';
import { DeviceListsCoCo } from './DeviceListsCoCo.js';
import { DeviceSelectionCoCo } from './DeviceSelectionCoCo.js';
import type { EmployeeProductListResponse } from '../../generated/api/employeeProductListResponse.js';
import type { EmployeeProductSelectionResponse } from '../../generated/api/employeeProductSelectionResponse.js';

import './DeviceListTabsCoCo.scss';

const TABS = [
  { id: DeviceListTabCoCo.DEVICE_LISTS, label: () => t.COBB(deviceListsMsg) },
  { id: DeviceListTabCoCo.DEVICE_SELECTION, label: () => t.AHB4(deviceSelectionMsg) },
];

export interface DeviceListTabsCoCoProps {
  deviceSelections: EmployeeProductSelectionResponse[];
  employeeProductLists: EmployeeProductListResponse[];
}

export const DeviceListTabsCoCo = ({ deviceSelections, employeeProductLists }: DeviceListTabsCoCoProps) => {
  const { selectedTab, selectTab } = useDeviceListTabsCoCo();

  return (
    <div className={`of-device-list-tabs-coco ${dsClass.MARGIN_TOP_4}`}>
      <fieldset className="of-device-list-tabs-coco__buttons" aria-label={t.COBB(deviceListsMsg)}>
        {TABS.map(({ id, label }) => (
          <button
            key={id}
            type="button"
            aria-pressed={selectedTab === id}
            className={classNames('of-device-list-tabs-coco__button', {
              ['of-device-list-tabs-coco__button--selected']: selectedTab === id,
            })}
            onClick={() => selectTab(id)}
          >
            {label()}
          </button>
        ))}
      </fieldset>
      {selectedTab === DeviceListTabCoCo.DEVICE_LISTS ? (
        <DeviceListsCoCo employeeProductLists={employeeProductLists} deviceSelections={deviceSelections} />
      ) : (
        <DeviceSelectionCoCo deviceSelections={deviceSelections} />
      )}
    </div>
  );
};
